"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
exports.SearchFieldSlot = function SearchFieldSlot(props) {
    return React.createElement(React.Fragment, null, props.children);
};
exports.SearchLegendSlot = function SearchFieldSlot(props) {
    return React.createElement(React.Fragment, null, props.children);
};
exports.SearchPassThroughSlot = function PassThroughSlot(props) {
    return React.createElement(React.Fragment, null, props.children);
};
exports.SearchResultListSlot = function SearchResultListSlot(props) {
    return React.createElement(React.Fragment, null, props.children);
};
exports.SearchResultPreviewSlot = function SearchResultPreviewSlot(props) {
    return React.createElement(React.Fragment, null, props.children);
};
function withSlot(children, { slot }) {
    return React.Children.toArray(children)
        .filter((child) => typeof child === 'object' && typeof child.type !== 'undefined')
        .filter(child => child.type === slot);
}
exports.withSlot = withSlot;
//# sourceMappingURL=search-slots.js.map